import React from "react";
import {
  Box,
  IconButton,
  Stack,
  MenuItem,
  Select,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import TemplatePage from "./TemplatePage";
import ShareIcon from "@mui/icons-material/Share";
import SettingsIcon from "@mui/icons-material/Settings";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";

function P2psection() {
  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      // justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Box>
        <Typography sx={{ color: "white" }}>Nav bar here</Typography>
      </Box>
      <Box
        sx={{
          width: "40%",
          height: "50%",
          borderRadius: "20px",
          backgroundColor: "#2C2D3A",
          padding: "30px",
        }}
      >
        <Stack direction="row" justifyContent="space-between">
          <Stack>
            <Typography
              variant="h6"
              color="primary"
              style={{ fontWeight: "bold" }}
            >
              P2P Exchange
            </Typography>
            <Typography variant="subtitle2" color="primary">
              Trade tokens in an instant
            </Typography>
          </Stack>
          <Stack direction="row" spacing={2}>
            <IconButton>
              <ShareIcon color="primary" fontSize="small" />
            </IconButton>
            <IconButton>
              <SettingsIcon color="primary" fontSize="small" />
            </IconButton>
          </Stack>
        </Stack>
        <hr style={{borderTop: "1px solid #3B3C4E"}}/>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "30px",
          }}
        >
          <Box sx={{ width: "70%" }}>
            <Stack spacing={1}>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="body2" color="secondary">
                  From
                </Typography>
                <Typography
                  variant="body2"
                  color="secondary"
                  sx={{ textDecoration: "underline" }}
                >
                  Available:
                </Typography>
              </Stack>
              <Select>
                <MenuItem>Item 1</MenuItem>
              </Select>
            </Stack>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingY: "10px",
              }}
            >
              <ArrowCircleDownIcon color="primary" />
            </Box>
            <Stack spacing={1}>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="body2" color="secondary">
                  To
                </Typography>
                <Typography
                  variant="body2"
                  color="secondary"
                  sx={{ textDecoration: "underline" }}
                >
                  Available:
                </Typography>
              </Stack>
              <Select>
                <MenuItem>Item 1</MenuItem>
              </Select>
            </Stack>
            <Stack alignItems="center" sx={{ paddingTop: "30px" }} spacing={1}>
              <Button
                variant="contained"
                color="gray18"
                fullWidth
                style={{ borderRadius: "10px", padding: "20px" }}
              >
                <Typography
                  variant="subtitle2"
                  color="primary"
                  style={{ fontWeight: "bold", textTransform: "none" }}
                >
                  Confirm Order
                </Typography>
              </Button>
              <Typography variant="caption" color="secondary">
                Enter an amount to see more trading details
              </Typography>
            </Stack>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
}

function TokenPurchase() {
  return (
    <TemplatePage>
      <P2psection />
    </TemplatePage>
  );
}

export default TokenPurchase;
